import { formatCurrency } from "../../../../helpers";
import { useCart } from "../../../../hooks/useCart";
import styles from "./styles.module.scss";
import { CartExtraButtonGroup } from "../CartExtraButtonGroup";

export const CartPriceSummary = ({
  orderDetails = null,
  showExtraBtn = false,
}) => {
  const {
    total_items_amount,
    vat_amount,
    vat,
    service_charge,
    service_charge_amount,
    discount,
    delivery_fee,
    giftcard,
    loyalty_point,
    totalCalculatedPrice,
    store_id,
    storeDetails,
  } = useCart({});
  const store_currency = storeDetails?.currency_code;

  return (
    <div className={styles.priceSummary}>
      {showExtraBtn && !orderDetails ? (
        <div>
          <CartExtraButtonGroup
            storeDetails={storeDetails}
            store_id={store_id}
            totalCalculatedPrice={totalCalculatedPrice}
            style={{ height: "55px" }}
          />
        </div>
      ) : null}
      <div>
        <p>Subtotal</p>
        <p className="dark--text font-weight-semibold">
          {formatCurrency({
            value: orderDetails?.total_item_amount || total_items_amount,
            currencyCode: store_currency,
          })}
        </p>
      </div>
      {(orderDetails?.giftcard_debit_amount || giftcard) && (
        <div>
          <p>Gift Card</p>
          <p className="dark--text font-weight-semibold">
            {formatCurrency({
              value: orderDetails?.giftcard_debit_amount || giftcard?.amount,
              currencyCode: store_currency,
            })}
          </p>
        </div>
      )}
      {(orderDetails?.loyalty_debit_amount || loyalty_point) && (
        <div>
          <p>Loyalty Amount</p>
          <p className="dark--text font-weight-semibold">
            {formatCurrency({
              value:
                orderDetails?.loyalty_debit_amount || loyalty_point?.amount,
              currencyCode: store_currency,
            })}
          </p>
        </div>
      )}
      <div>
        <p>Discount</p>
        <p className="dark--text font-weight-semibold">
          {formatCurrency({
            value: orderDetails?.discount_amount || discount?.amount || 0,
            currencyCode: store_currency,
          })}
        </p>
      </div>
      <div>
        <p>Delivery Fee</p>
        <p className="dark--text font-weight-semibold">
          {formatCurrency({
            value:
              orderDetails?.delivery_fee_amount || delivery_fee?.amount || 0,
            currencyCode: store_currency,
          })}
        </p>
      </div>
      <div>
        <p>VAT ({vat}%)</p>
        <p className="dark--text font-weight-semibold">
          {formatCurrency({
            value: orderDetails?.vat || vat_amount,
            currencyCode: store_currency,
          })}
        </p>
      </div>
      <div>
        <p>
          Service Charge (
          {isNaN(Number(service_charge)) ? 0 : Number(service_charge)}%)
        </p>
        <p className="dark--text font-weight-semibold">
          {formatCurrency({
            value: orderDetails?.service_charge || service_charge_amount,
            currencyCode: store_currency,
          })}
        </p>
      </div>
      <div>
        <p className="dark--text font-weight-semibold">Total</p>
        <h5 className="success--text">
          {formatCurrency({
            value: orderDetails?.total_amount || totalCalculatedPrice,
            currencyCode: store_currency,
          })}
        </h5>
      </div>
    </div>
  );
};
